"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _orderBy = _interopRequireDefault(require("lodash/orderBy"));
var _sumBy = _interopRequireDefault(require("lodash/sumBy"));
var _utils = require("@gravity/utils");
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _product = require("@nucleo/product");
var _jsxFileName = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductHeader.js",
  _templateObject,
  _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2pcizov1wf() {
  var path = "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductHeader.js";
  var hash = "5ea6908688b843ae1b8b4d243ba3346a3fa1836c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1854190349/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/ProductHeader.js",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 23
        }
      },
      "1": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "2": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 26,
          column: 35
        }
      },
      "3": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 30,
          column: 35
        }
      },
      "4": {
        start: {
          line: 37,
          column: 15
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "5": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 38
        }
      },
      "6": {
        start: {
          line: 41,
          column: 26
        },
        end: {
          line: 41,
          column: 60
        }
      },
      "7": {
        start: {
          line: 48,
          column: 30
        },
        end: {
          line: 48,
          column: 81
        }
      },
      "8": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 51,
          column: 37
        }
      },
      "9": {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 67,
          column: 41
        }
      },
      "10": {
        start: {
          line: 85,
          column: 10
        },
        end: {
          line: 86,
          column: 41
        }
      },
      "11": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 17
        }
      },
      "12": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 102,
          column: 6
        }
      },
      "13": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 95
        }
      },
      "14": {
        start: {
          line: 103,
          column: 77
        },
        end: {
          line: 103,
          column: 93
        }
      },
      "15": {
        start: {
          line: 113,
          column: 22
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "16": {
        start: {
          line: 114,
          column: 23
        },
        end: {
          line: 114,
          column: 40
        }
      },
      "17": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 124,
          column: 6
        }
      },
      "18": {
        start: {
          line: 116,
          column: 20
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "19": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 41
        }
      },
      "20": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 45
        }
      },
      "21": {
        start: {
          line: 129,
          column: 27
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "22": {
        start: {
          line: 131,
          column: 15
        },
        end: {
          line: 131,
          column: 28
        }
      },
      "23": {
        start: {
          line: 134,
          column: 22
        },
        end: {
          line: 156,
          column: 6
        }
      },
      "24": {
        start: {
          line: 135,
          column: 17
        },
        end: {
          line: 135,
          column: 41
        }
      },
      "25": {
        start: {
          line: 136,
          column: 25
        },
        end: {
          line: 136,
          column: 72
        }
      },
      "26": {
        start: {
          line: 137,
          column: 25
        },
        end: {
          line: 137,
          column: 41
        }
      },
      "27": {
        start: {
          line: 138,
          column: 28
        },
        end: {
          line: 138,
          column: 58
        }
      },
      "28": {
        start: {
          line: 139,
          column: 27
        },
        end: {
          line: 139,
          column: 29
        }
      },
      "29": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 142,
          column: 7
        }
      },
      "30": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 64
        }
      },
      "31": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 155,
          column: 8
        }
      },
      "32": {
        start: {
          line: 150,
          column: 25
        },
        end: {
          line: 150,
          column: 76
        }
      },
      "33": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 42
        }
      },
      "34": {
        start: {
          line: 161,
          column: 0
        },
        end: {
          line: 177,
          column: 2
        }
      },
      "35": {
        start: {
          line: 179,
          column: 0
        },
        end: {
          line: 183,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 24,
            column: 12
          }
        },
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 35
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 28,
            column: 19
          }
        },
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 40,
            column: 11
          },
          end: {
            line: 40,
            column: 12
          }
        },
        loc: {
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 40,
            column: 38
          }
        },
        line: 40
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 16
          },
          end: {
            line: 41,
            column: 17
          }
        },
        loc: {
          start: {
            line: 41,
            column: 26
          },
          end: {
            line: 41,
            column: 60
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 48,
            column: 20
          },
          end: {
            line: 48,
            column: 21
          }
        },
        loc: {
          start: {
            line: 48,
            column: 30
          },
          end: {
            line: 48,
            column: 81
          }
        },
        line: 48
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 49,
            column: 13
          },
          end: {
            line: 49,
            column: 14
          }
        },
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 51,
            column: 37
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 65,
            column: 31
          },
          end: {
            line: 65,
            column: 32
          }
        },
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 67,
            column: 41
          }
        },
        line: 66
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 84,
            column: 28
          },
          end: {
            line: 84,
            column: 29
          }
        },
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 86,
            column: 41
          }
        },
        line: 85
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 97,
            column: 3
          }
        },
        loc: {
          start: {
            line: 97,
            column: 21
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 97
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 103,
            column: 67
          },
          end: {
            line: 103,
            column: 68
          }
        },
        loc: {
          start: {
            line: 103,
            column: 77
          },
          end: {
            line: 103,
            column: 93
          }
        },
        line: 103
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 23
          }
        },
        loc: {
          start: {
            line: 113,
            column: 40
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 113
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        },
        loc: {
          start: {
            line: 116,
            column: 20
          },
          end: {
            line: 119,
            column: 7
          }
        },
        line: 116
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        },
        loc: {
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 123,
            column: 7
          }
        },
        line: 120
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 158,
            column: 3
          }
        },
        line: 127
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 7
          }
        },
        loc: {
          start: {
            line: 131,
            column: 15
          },
          end: {
            line: 131,
            column: 28
          }
        },
        line: 131
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 134,
            column: 41
          },
          end: {
            line: 134,
            column: 42
          }
        },
        loc: {
          start: {
            line: 134,
            column: 49
          },
          end: {
            line: 156,
            column: 5
          }
        },
        line: 134
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 150,
            column: 19
          },
          end: {
            line: 150,
            column: 20
          }
        },
        loc: {
          start: {
            line: 150,
            column: 25
          },
          end: {
            line: 150,
            column: 76
          }
        },
        line: 150
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 182,
            column: 17
          },
          end: {
            line: 182,
            column: 18
          }
        },
        loc: {
          start: {
            line: 182,
            column: 23
          },
          end: {
            line: 182,
            column: 25
          }
        },
        line: 182
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 5
          },
          end: {
            line: 25,
            column: 16
          }
        }, {
          start: {
            line: 25,
            column: 20
          },
          end: {
            line: 25,
            column: 39
          }
        }, {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 25,
            column: 76
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 26,
            column: 35
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 5
          },
          end: {
            line: 29,
            column: 16
          }
        }, {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 39
          }
        }, {
          start: {
            line: 29,
            column: 43
          },
          end: {
            line: 29,
            column: 74
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 35
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 26
          },
          end: {
            line: 41,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 43
          },
          end: {
            line: 41,
            column: 51
          }
        }, {
          start: {
            line: 41,
            column: 54
          },
          end: {
            line: 41,
            column: 60
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 48,
            column: 30
          },
          end: {
            line: 48,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 47
          },
          end: {
            line: 48,
            column: 48
          }
        }, {
          start: {
            line: 48,
            column: 51
          },
          end: {
            line: 48,
            column: 81
          }
        }],
        line: 48
      },
      "4": {
        loc: {
          start: {
            line: 50,
            column: 6
          },
          end: {
            line: 51,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 7
          },
          end: {
            line: 50,
            column: 18
          }
        }, {
          start: {
            line: 50,
            column: 22
          },
          end: {
            line: 50,
            column: 41
          }
        }, {
          start: {
            line: 50,
            column: 45
          },
          end: {
            line: 50,
            column: 78
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 37
          }
        }],
        line: 50
      },
      "5": {
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 67,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 11
          },
          end: {
            line: 66,
            column: 22
          }
        }, {
          start: {
            line: 66,
            column: 26
          },
          end: {
            line: 66,
            column: 45
          }
        }, {
          start: {
            line: 66,
            column: 49
          },
          end: {
            line: 66,
            column: 76
          }
        }, {
          start: {
            line: 67,
            column: 10
          },
          end: {
            line: 67,
            column: 41
          }
        }],
        line: 66
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 10
          },
          end: {
            line: 86,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 11
          },
          end: {
            line: 85,
            column: 22
          }
        }, {
          start: {
            line: 85,
            column: 26
          },
          end: {
            line: 85,
            column: 45
          }
        }, {
          start: {
            line: 85,
            column: 49
          },
          end: {
            line: 85,
            column: 76
          }
        }, {
          start: {
            line: 86,
            column: 10
          },
          end: {
            line: 86,
            column: 41
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 118,
            column: 20
          },
          end: {
            line: 118,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 118,
            column: 61
          },
          end: {
            line: 118,
            column: 82
          }
        }, {
          start: {
            line: 118,
            column: 85
          },
          end: {
            line: 118,
            column: 89
          }
        }],
        line: 118
      },
      "8": {
        loc: {
          start: {
            line: 136,
            column: 25
          },
          end: {
            line: 136,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 136,
            column: 42
          },
          end: {
            line: 136,
            column: 56
          }
        }, {
          start: {
            line: 136,
            column: 59
          },
          end: {
            line: 136,
            column: 72
          }
        }],
        line: 136
      },
      "9": {
        loc: {
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 6
          },
          end: {
            line: 142,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 140
      },
      "10": {
        loc: {
          start: {
            line: 141,
            column: 25
          },
          end: {
            line: 141,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 141,
            column: 49
          },
          end: {
            line: 141,
            column: 54
          }
        }, {
          start: {
            line: 141,
            column: 57
          },
          end: {
            line: 141,
            column: 63
          }
        }],
        line: 141
      },
      "11": {
        loc: {
          start: {
            line: 150,
            column: 25
          },
          end: {
            line: 150,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 25
          },
          end: {
            line: 150,
            column: 44
          }
        }, {
          start: {
            line: 150,
            column: 48
          },
          end: {
            line: 150,
            column: 76
          }
        }],
        line: 150
      },
      "12": {
        loc: {
          start: {
            line: 151,
            column: 11
          },
          end: {
            line: 153,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 11
          },
          end: {
            line: 151,
            column: 29
          }
        }, {
          start: {
            line: 152,
            column: 12
          },
          end: {
            line: 152,
            column: 84
          }
        }],
        line: 151
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ea6908688b843ae1b8b4d243ba3346a3fa1836c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pcizov1wf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pcizov1wf();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var weightDefault = (cov_2pcizov1wf().s[0]++, 1);
var Wrapper = (cov_2pcizov1wf().s[1]++, _styledComponents.default.div.attrs({
  className: "stx-ProductHeader"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: ", ";\n  padding: ", " 0;\n  position: relative;\n  color: ", ";\n  border-width: ", " 0 0 0;\n  border-color: ", ";\n  border-style: solid;\n  @media (max-width: 30em) {\n    display: none;\n  }\n"])), _stylingConstants.default.spacing.small, _stylingConstants.default.spacing.medium, function (props) {
  cov_2pcizov1wf().f[0]++;
  cov_2pcizov1wf().s[2]++;
  return (cov_2pcizov1wf().b[0][0]++, props.theme) && (cov_2pcizov1wf().b[0][1]++, props.theme.product) && (cov_2pcizov1wf().b[0][2]++, props.theme.product.nameTextColor) || (cov_2pcizov1wf().b[0][3]++, _stylingConstants.default.color.baseText);
}, _stylingConstants.default.border.widthBase, function (props) {
  cov_2pcizov1wf().f[1]++;
  cov_2pcizov1wf().s[3]++;
  return (cov_2pcizov1wf().b[1][0]++, props.theme) && (cov_2pcizov1wf().b[1][1]++, props.theme.product) && (cov_2pcizov1wf().b[1][2]++, props.theme.product.borderColor) || (cov_2pcizov1wf().b[1][3]++, _stylingConstants.default.color.baseText);
}));
var Column = (cov_2pcizov1wf().s[4]++, _styledComponents.default.a.attrs({
  className: 'stx-ProductHeaderColumn'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: ", ";\n  text-align: ", ";\n  &:hover {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  span {\n    position: relative;\n    padding-left: ", ";\n    color: ", ";\n    display: 'inline';\n  }\n  &.asc {\n    span {\n      &:after {\n        bottom: 5px;\n        right: -20px;\n        border: solid transparent;\n        content: ' ';\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n        border-bottom-color: ", ";\n        border-width: 5px;\n        margin-left: 5px;\n      }\n    }\n  }\n  &.desc {\n    span {\n      &:after {\n        top: 5px;\n        right: -20px;\n        border: solid transparent;\n        content: ' ';\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n        border-top-color: ", ";\n        border-width: 5px;\n        margin-left: 5px;\n      }\n    }\n  }\n"])), function (props) {
  cov_2pcizov1wf().f[2]++;
  cov_2pcizov1wf().s[5]++;
  return "".concat(props.weight, "%");
}, function (props) {
  cov_2pcizov1wf().f[3]++;
  cov_2pcizov1wf().s[6]++;
  return props.centered ? (cov_2pcizov1wf().b[2][0]++, 'center') : (cov_2pcizov1wf().b[2][1]++, 'left');
}, function (props) {
  cov_2pcizov1wf().f[4]++;
  cov_2pcizov1wf().s[7]++;
  return props.centered ? (cov_2pcizov1wf().b[3][0]++, 0) : (cov_2pcizov1wf().b[3][1]++, _stylingConstants.default.spacing.small);
}, function (props) {
  cov_2pcizov1wf().f[5]++;
  cov_2pcizov1wf().s[8]++;
  return (cov_2pcizov1wf().b[4][0]++, props.theme) && (cov_2pcizov1wf().b[4][1]++, props.theme.product) && (cov_2pcizov1wf().b[4][2]++, props.theme.product.nameTextColor) || (cov_2pcizov1wf().b[4][3]++, _stylingConstants.default.color.baseText);
}, function (props) {
  cov_2pcizov1wf().f[6]++;
  cov_2pcizov1wf().s[9]++;
  return (cov_2pcizov1wf().b[5][0]++, props.theme) && (cov_2pcizov1wf().b[5][1]++, props.theme.product) && (cov_2pcizov1wf().b[5][2]++, props.theme.product.fillSvg) || (cov_2pcizov1wf().b[5][3]++, _stylingConstants.default.color.baseText);
}, function (props) {
  cov_2pcizov1wf().f[7]++;
  cov_2pcizov1wf().s[10]++;
  return (cov_2pcizov1wf().b[6][0]++, props.theme) && (cov_2pcizov1wf().b[6][1]++, props.theme.product) && (cov_2pcizov1wf().b[6][2]++, props.theme.product.fillSvg) || (cov_2pcizov1wf().b[6][3]++, _stylingConstants.default.color.baseText);
}));
var totalWeight;
var ProductHeader = /*#__PURE__*/function (_PureComponent) {
  function ProductHeader(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ProductHeader);
    cov_2pcizov1wf().f[8]++;
    cov_2pcizov1wf().s[11]++;
    _this = _callSuper(this, ProductHeader, [props]);
    /**
     * Method to be called when a column has been clicked to be order
     * @param  {object} selectedColumn Column selected
     *
     * Set the column to be ordered by the 'sortingAsc' property:
     * If this property is true, then the order will be ascendant
     */
    (0, _defineProperty2.default)(_this, "changeOrderColumn", (cov_2pcizov1wf().s[15]++, function (selectedColumn) {
      cov_2pcizov1wf().f[10]++;
      var columnName = (cov_2pcizov1wf().s[16]++, selectedColumn[0]);
      cov_2pcizov1wf().s[17]++;
      _this.setState(function (prevState) {
        cov_2pcizov1wf().f[11]++;
        cov_2pcizov1wf().s[18]++;
        return {
          sortingColumn: columnName,
          sortingAsc: columnName === prevState.sortingColumn ? (cov_2pcizov1wf().b[7][0]++, !prevState.sortingAsc) : (cov_2pcizov1wf().b[7][1]++, true)
        };
      }, function () {
        cov_2pcizov1wf().f[12]++;
        cov_2pcizov1wf().s[19]++;
        selectedColumn[1].handleAction();
        cov_2pcizov1wf().s[20]++;
        _this.props.onHeaderOrder(_this.state);
      });
    }));
    cov_2pcizov1wf().s[12]++;
    _this.state = {
      sortingColumn: 'dateTime',
      sortingAsc: true
    };
    cov_2pcizov1wf().s[13]++;
    totalWeight = (0, _sumBy.default)((0, _entries.default)(_this.props.cellDefinition), function (column) {
      cov_2pcizov1wf().f[9]++;
      cov_2pcizov1wf().s[14]++;
      return column[1].weight;
    });
    return _this;
  }
  (0, _inherits2.default)(ProductHeader, _PureComponent);
  return (0, _createClass2.default)(ProductHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_2pcizov1wf().f[13]++;
      // Order the columns by rank
      var columnsOrdered = (cov_2pcizov1wf().s[21]++, (0, _orderBy.default)((0, _entries.default)(this.props.cellDefinition), function (value) {
        cov_2pcizov1wf().f[14]++;
        cov_2pcizov1wf().s[22]++;
        return value[1].rank;
      }));
      var headerRow = (cov_2pcizov1wf().s[23]++, columnsOrdered.map(function (item) {
        cov_2pcizov1wf().f[15]++;
        var id = (cov_2pcizov1wf().s[24]++, (0, _utils.uuid)('ts-ProductHeader'));
        var itemWeight = (cov_2pcizov1wf().s[25]++, item[1].weight ? (cov_2pcizov1wf().b[8][0]++, item[1].weight) : (cov_2pcizov1wf().b[8][1]++, weightDefault));
        var isCentered = (cov_2pcizov1wf().s[26]++, item[1].centered);
        var percentColumn = (cov_2pcizov1wf().s[27]++, itemWeight / totalWeight * 100);
        var orderClassName = (cov_2pcizov1wf().s[28]++, '');
        cov_2pcizov1wf().s[29]++;
        if (item[0] === _this2.state.sortingColumn) {
          cov_2pcizov1wf().b[9][0]++;
          cov_2pcizov1wf().s[30]++;
          orderClassName = _this2.state.sortingAsc ? (cov_2pcizov1wf().b[10][0]++, 'asc') : (cov_2pcizov1wf().b[10][1]++, 'desc');
        } else {
          cov_2pcizov1wf().b[9][1]++;
        }
        cov_2pcizov1wf().s[31]++;
        return /*#__PURE__*/_react.default.createElement(Column, (0, _extends2.default)({}, _this2.props, {
          centered: isCentered,
          className: orderClassName,
          key: id,
          weight: percentColumn,
          onClick: function onClick() {
            cov_2pcizov1wf().f[16]++;
            cov_2pcizov1wf().s[32]++;
            return (cov_2pcizov1wf().b[11][0]++, _this2.props.sortable) && (cov_2pcizov1wf().b[11][1]++, _this2.changeOrderColumn(item));
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 144,
            columnNumber: 9
          }
        }), (cov_2pcizov1wf().b[12][0]++, item[1].showHeader) && (cov_2pcizov1wf().b[12][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.Product.ProductHeader.".concat(item[0]),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 152,
            columnNumber: 13
          }
        })));
      }));
      cov_2pcizov1wf().s[33]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157,
          columnNumber: 12
        }
      }, headerRow);
    }
  }]);
}(_react.PureComponent);
cov_2pcizov1wf().s[34]++;
ProductHeader.propTypes = {
  /*
  Define the columns of header with differents properties:
  - showHeader: Indicates if it will be shown in the header
  - centered: Indicates if content has to be aligned centered
  - rank: Indicates the order of the column
  - weight: Indicates the importance of column
  - handleAction: Action to be made when click over the column
   */
  cellDefinition: _propTypes.default.shape(_product.ProductRowType).isRequired,
  /* Indicate if the column is sortable */
  sortable: _propTypes.default.bool,
  /**
   * Method to be called when click over a column
   */
  onHeaderOrder: _propTypes.default.func
};
cov_2pcizov1wf().s[35]++;
ProductHeader.defaultProps = {
  sortable: true,
  centered: false,
  onHeaderOrder: function onHeaderOrder() {
    cov_2pcizov1wf().f[17]++;
  }
};
var _default = exports.default = ProductHeader;